import React, { useState } from "react";
import { Grid, FormControl, Button } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import "../InvoicingIATA.css";
import DateLocalizationProvider from "../../../../components/element/DateLocalizationProvider";
import { DATE_FORMAT } from "../../../../utils/constants";
import dayjs from "dayjs";

const InvoicingIATAFilter = ({ onClickClear, onClickApply }) => {
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [selectedInvoiceDate, setSelectedInvoiceDate] = useState(null);

  const handleInvoiceNumberChange = (event) => {
    setInvoiceNumber(event.target.value);
  };

  const handleInvoiceDateChange = (newValue) => {
    setSelectedInvoiceDate(newValue);
  };

  const handleClearFilter = () => {
    setInvoiceNumber("");
    setSelectedInvoiceDate(null);
    onClickClear();
  };

  return (
    <div className="invoicing-IATA-filter-container">
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <FormControl variant="outlined">
                <div className="invoicing-IATA-filter-header">
                  Invoice Number
                </div>
                <input
                  name="invoicing-IATA-filter-invoice-number"
                  value={invoiceNumber}
                  onChange={handleInvoiceNumberChange}
                  maxLength={15}
                />
              </FormControl>
            </Grid>

            <DateLocalizationProvider>
              <Grid item>
                <FormControl variant="outlined">
                  <div className="invoicing-IATA-filter-header">
                    Invoice Date
                  </div>
                  <MobileDatePicker
                    id="invoicing-IATA-filter-departure-datepicker"
                    className="invoicing-IATA-filter-datepicker"
                    format={DATE_FORMAT}
                    maxDate={dayjs()}
                    value={selectedInvoiceDate}
                    onChange={handleInvoiceDateChange}
                  />
                </FormControl>
              </Grid>
            </DateLocalizationProvider>
          </Grid>
        </Grid>

        <Grid item>
          <div className="invoicing-IATA-filter-button-container">
            <Button className="clear" onClick={handleClearFilter}>
              Clear
            </Button>
            <Button
              variant="contained"
              color="secondaryButton"
              onClick={() => onClickApply(invoiceNumber, selectedInvoiceDate)}
            >
              Apply
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default InvoicingIATAFilter;
